import { memo, useEffect, useMemo, useState } from "react";
import { BzButton, BzChip, BzLoader, BzToolTip } from "../../../components";
import KeyStats from "../../MarketOverview/KeyStats";
import { useDispatch, useSelector } from "react-redux";
import { setScripOverviewData, updateSideOverViewWatchlistSynced } from "../../../redux/actions/marketOverview";
import Technical from "../../Analysis/Technical";
import Fundamental from "../../Analysis/Fundamental";
import MarketMovement from "../../MarketOverview/MarketMovement";
import { Col, Container, Row, Stack } from "react-bootstrap";
import { WATCHLIST_GRID_REF, getScripDisplayDescription } from "../../../utils/global_functions";
import { BEST5_INDEX, DISPLAY_EXCHANGE_NAME, FACILITY_NUM, MARKET_OVER_VIEW_TAB_KEYS, SIDE_TRAY_EXPAND_PERCENTAGE, WATCHLIST_GRID_INDEX } from "../../../utils/global_variables";
import { getFocusedCard } from "../../../redux/actions/watchlist";
import Recommendations from "../../Recommendations";
import ContainerBody from "./ContainerBody";
import ContainerHeader from "./ContainerHeader";
import { uniqBy } from "lodash";
import MarketDepthGrid from "../../MarketOverview/MarketDepthGrid";
import PriceLadderView from "../../MarketOverview/PriceLadderView";
import SideAlerts from "./SideAlerts";
import { handleModal } from "../../../redux/actions/modals";
import ZeroStates from "../../ZeroStates";
import NewsAnnouncements from "../../MarketOverview/NewsAnnouncements";
import CorporateActions from "../../MarketOverview/CorporateActions";
import { boardMeeting, bonusData, bookClosure, buyBackData, dividendData, getAgmEgmData, rightsData, splitData } from "../../../redux/actions/events";
import { scripWiseNewsData } from "../../../redux/actions/news";
import NewsDetailsModal from "../../News/NewsDetailsModal";
import CorporateActionsDetails from "../../MarketOverview/CorporateActionsDetails";
import { useWFHMessages } from "../../../hooks";
import { getWfhBestFiveLastTick } from "../../../redux/actions/wfh";
import { sendBestFiveRequest } from "../../../apis/web_socket";
const SideOverview = ({ handleOptionAndChart, bIsFutureAndOptionTab, scripOnExpand, sideContentId, setSyncWatchlist, syncWatchlist, handleOptionChain, optionChainToShow, setToggleSideContainer, setActiveMenu, isExpanded, setIsExpanded, handleChart, chartToShow, ...props }) => {

    const objCFT = useSelector(state => state?.auth?.objCFT);
    const arrMainMenus = [
        { name: 'Key Stats', id: 'keystats' },
        { name: 'Fundamentals', id: 'fundamentals' },
        { name: 'Technical', id: 'technical' }
    ];
    const arrRecNewsEvents = useMemo(() => {
        return [
            { name: 'Events', id: 'events' },
            { name: 'Recommendations', id: 'recommendation' },
            ...(objCFT.ALERT === FACILITY_NUM.ON && [{ name: 'Alert', id: 'alert' }] || [])
        ];
    }, objCFT);
    const page = '1';
    const pageSize = "10";
    const jtenantToken = 1;
    const recordSize = '100';
    const scripNewsPage = 10;

    const dispatch = useDispatch();
    const [activeTabKey, setAvtiveTabKey] = useState("keystats");
    const [checkExchangeShow, setCheckExchangeShow] = useState({ "NSE": true, "BSE": true, "NSECDS": true, "BSECDS": true, "MCX": true, "NSECOMM": true, "BSECOMM": true });
    const [showDrop, setShowDrop] = useState(false);
    const [showDropMarket, setShowDropMarket] = useState(false);
    const [showDropRecommendation, setShowDropRecommendation] = useState(false);
    const [showDropMarketMoveMent, setShowDropMarketMoveMent] = useState(false);
    const [marketDepthToShow, setMarketDepthToShow] = useState(false);
    const [activeNews, setActiveNews] = useState({});
    const [newsShow, setNewsShow] = useState(false);
    const [detailedEvent, setDetailedEvent] = useState();
    const [nCorporateAction, setnCorporateAction] = useState();
    const [activeTabKeyRecNewsEvents, setActiveTabKeyRecNewsEvents] = useState('events');
    const [arrScripInfo,setArrScripInfo] = useState([])

    const hotPursuitData = useSelector(state => state?.news?.hotPursuitData);
    const modals = useSelector(state => state?.modals?.modals);
    const bIsSectorWiseNewsDetailsApiPending = useSelector(state => state?.news?.bIsSectorWiseNewsDetailsApiPending);
    const boardMeetings = useSelector(state => state?.events?.boardMeeting);
    const bookClosures = useSelector(state => state?.events?.bookClosure);
    const split = useSelector(state => state?.events?.split);
    const bonus = useSelector(state => state?.events?.bonus);
    const dividend = useSelector(state => state?.events?.dividend);
    const rights = useSelector(state => state?.events?.rights);
    const agm = useSelector(state => state?.events?.agm);
    const egm = useSelector(state => state?.events?.egm);
    const buy_back = useSelector(state => state?.events?.buy_back);
    const isHotPursuitAPIFailed = useSelector(state => state?.news?.isHotPursuitAPIFailed);
    const arrScripExchanges = useSelector(state => state.orders.arrScripExchanges);
    const objScripOrderInfo = useSelector(state => state.orders.scripOrderInfo);
    const scripOverviewData = useSelector(state => state?.marketOverview?.scripOverviewData);

    //Vaibhav Singh: Tabs for EVents added in memo
    const { scripOrderInfo, activeButtonToggleIndex, activeMktSegId } = useMemo(() => ({ scripOrderInfo: objScripOrderInfo?.scripData, activeButtonToggleIndex: objScripOrderInfo?.isBuySell, activeMktSegId: objScripOrderInfo?.activeExchangeId }), [objScripOrderInfo]);
    const arrDistinctScripExchanges = useMemo(() => uniqBy(arrScripExchanges, WATCHLIST_GRID_INDEX.EXCHANGE), [arrScripExchanges]);
    const arrCorporateActionTypes = useMemo(() => [
        {
            id: 1,
            Title: 'Board Meeting',
            type: 'board_meeting',
            label: 'Board Meeting',
            data: boardMeetings?.length > 0 ? boardMeetings?.reverse() : [],
            isUpcomming: (boardMeetings?.length > 0 ? boardMeetings?.some((each) => each?.Upcoming === true) : false),
        }, {
            id: 2,
            Title: 'Book Closure',
            type: 'book_closure',
            label: 'Book Closure',
            data: bookClosures?.length > 0 ? bookClosures?.reverse() : [],
            isUpcomming: (bookClosures?.length > 0 ? bookClosures?.some((each) => each?.Upcoming === true) : false),
        }, {
            id: 3,
            Title: 'AGM',
            type: 'agm',
            label: 'AGM',
            data: agm?.length > 0 ? agm?.reverse() : [],
            isUpcomming: (agm?.length > 0 ? agm?.some((each) => each?.Upcoming === true) : false),
        }, {
            id: 4,
            Title: 'EGM',
            type: 'egm',
            label: 'EGM',
            data: egm?.length > 0 ? egm?.reverse() : [],
            isUpcomming: (egm?.length > 0 ? egm?.some((each) => each?.Upcoming === true) : false),
        }, {
            id: 5,
            Title: 'Split',
            type: 'split',
            label: 'Split Announced',
            data: split?.length > 0 ? split?.reverse() : [],
            isUpcomming: (split?.length > 0 ? split?.some((each) => each?.Upcoming === true) : false),
        }, {
            id: 6,
            Title: 'Dividend',
            type: 'dividend',
            label: 'Dividend Declared',
            data: dividend?.length > 0 ? dividend?.reverse() : [],
            isUpcomming: (dividend?.length > 0 ? dividend?.some((each) => each?.Upcoming === true) : false),
        }, {
            id: 7,
            Title: 'Buy Back',
            type: 'buy_back',
            label: 'Buy Back',
            data: buy_back?.length > 0 ? buy_back?.reverse() : [],
            isUpcomming: (buy_back?.length > 0 ? buy_back?.some((each) => each?.Upcoming === true) : false),
        }, {
            id: 8,
            Title: 'Rights',
            type: 'rights',
            label: 'Rights',
            data: rights?.length > 0 ? rights?.reverse() : [],
            isUpcomming: (rights?.length > 0 ? rights?.some((each) => each?.Upcoming === true) : false),
        }, {
            id: 9,
            Title: 'Bonus',
            type: 'bonus',
            label: 'Bonus',
            data: bonus?.length > 0 ? bonus?.reverse() : [],
            isUpcomming: (bonus?.length > 0 ? bonus?.some((each) => each?.Upcoming === true) : false),
        },
    ], [boardMeetings, bookClosures, bonus, rights, buy_back, dividend, split, egm, agm]);
    //Vaibhav Singh: Api calls Added for Evnets
    useEffect(() => {
        if (activeTabKeyRecNewsEvents === MARKET_OVER_VIEW_TAB_KEYS?.EVENTS) {
            dispatch(scripWiseNewsData(scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], scripNewsPage, jtenantToken));
            dispatch(boardMeeting(scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], '-', '-', page, pageSize, jtenantToken));
            dispatch(bookClosure(scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], jtenantToken));
            dispatch(getAgmEgmData(scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], 'AGM', '-', '-', page, pageSize, jtenantToken));
            dispatch(getAgmEgmData(scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], 'EGM', '-', '-', page, pageSize, jtenantToken));
            dispatch(splitData(scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], recordSize, '-', '-', page, pageSize, jtenantToken));
            dispatch(dividendData(scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], recordSize, '-', '-', page, pageSize, jtenantToken));
            dispatch(buyBackData(scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], jtenantToken));
            dispatch(rightsData(scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], jtenantToken));
            dispatch(bonusData(scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], '-', '-', page, pageSize, jtenantToken));
            if (nCorporateAction === undefined) {
                setnCorporateAction(arrCorporateActionTypes[0]);
            } else { }
        }
    }, [activeTabKeyRecNewsEvents, scripOverviewData]);

    useEffect(() => {
        let arrScrip = [{
            exchangeId: scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID],
            token: scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN],
            isSubscribe: true
        }];
        sendBestFiveRequest(arrScrip);

        return () => {
            let arrScrip = [{
                exchangeId: scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID],
                token: scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN],
                isSubscribe: false
            }];
            sendBestFiveRequest(arrScrip);
        };
    }, [scripOverviewData]);

    //Vaibhav Singh: Set nCorporateAction to o index in case of no data
    useEffect(() => {
        if (nCorporateAction === undefined) {
            if (arrCorporateActionTypes?.length > 0) {
                setnCorporateAction(arrCorporateActionTypes[0]);
            }
        } else { }
    }, []);
    useEffect(() => {
        if (syncWatchlist) {
            dispatch(setScripOverviewData(scripOnExpand));
        }
    }, [dispatch, scripOnExpand]);
    useEffect(() => {
        if (!scripOverviewData?.length && scripOrderInfo?.length) {
            dispatch(setScripOverviewData(scripOrderInfo));
        }
        if (!scripOverviewData[WATCHLIST_GRID_INDEX.SERIES]) {
            setAvtiveTabKey('keystats');
        }
    }, [scripOverviewData]);
    useEffect(() => {
        if (WATCHLIST_GRID_REF?.current?.api?.getDisplayedRowAtIndex(0)?.data) {
            if (WATCHLIST_GRID_REF?.current?.api?.getSelectedRows()[0]?.length) {
                dispatch(setScripOverviewData(WATCHLIST_GRID_REF.current?.api?.getSelectedRows()[0]));
            } else {
                dispatch(setScripOverviewData(WATCHLIST_GRID_REF?.current?.api.getDisplayedRowAtIndex(0)?.data));
            }
        }
    }, []);
    useEffect(() => {
        if (scripOrderInfo?.length && syncWatchlist) {
            dispatch(setScripOverviewData(scripOrderInfo));
            dispatch(getFocusedCard(scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]));
        }
    }, [scripOrderInfo]);
    const handleTabs = (each) => {
        setAvtiveTabKey(each);
    };
    const handleTabsRec = (each) => {
        setActiveTabKeyRecNewsEvents(each);
    };

    //Vaibhav Singh: 23-10-24: Sync watchlist is to upadte scrip in sidetray when user select another scrip
    const handleSync = () => {
        if (!syncWatchlist) {
            dispatch(setScripOverviewData(scripOrderInfo));
        }
        setSyncWatchlist(prevState => {
            dispatch(updateSideOverViewWatchlistSynced(!prevState));
            return !prevState;
        });
    };
    // Vaibhav Singh: 28-10-24: HandleDropClick & handleDropClickMarketDepth will help toggle width of area for market depth
    // Vaibhav Singh: 28-10-24: handleMarketDepth & handleMarketDepthChange will update checkbox and let user choose which exchange to show
    const handleDropClick = () => {
        setShowDrop(!showDrop);
    };


    //Vaibhav Singh:Added modal click of news & Events
    const handleNewsDetails = (objActiveNewsData) => {
        setActiveNews(objActiveNewsData);
        dispatch(handleModal([{ "HOT_PURSUIT_DATA": true }]));
    };
    const handleEventsDetails = (event) => {
        setDetailedEvent(event);
        dispatch(handleModal([{ "CORPORATE_ACTIONS_DETAILS": true }]));
    };
    const handleMarketDepthChange = (bool) => {
        setMarketDepthToShow(bool);
    };
    const handleDropClickMarketDepth = () => {
        setShowDropMarket(!showDropMarket);
    };
    const handleDropClickMarketMovement = () => {
        setShowDropMarketMoveMent(!showDropMarketMoveMent);
    };

    //Vaibhav Singh:Expand Button for news& events
    const handleDropClickRecommendation = () => {
        setShowDropRecommendation(!showDropRecommendation);
    };
    const handleMarketDepth = (each, curr) => {
        if (!(Object.values(checkExchangeShow)?.includes(false) && curr === true) && arrDistinctScripExchanges?.length > 1) {
            setCheckExchangeShow(prev => ({
                ...prev,
                [each]: !curr
            }));
        }
    };
    //Vaibhav Singh:Toggle ViewMore & Less button in Events
    const handleNews = () => {
        setNewsShow(!newsShow);
    };
    useWFHMessages('bestfive', (e) => {
        if (`${e.detail[BEST5_INDEX.SEGMENT_ID]}_${e.detail[BEST5_INDEX.TOKEN]}` === scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]) {
            setArrScripInfo([...e.detail])
        }
    });
    useEffect(() => {
        if (scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]) {
            const objLastTickData = dispatch(getWfhBestFiveLastTick());
            const arrLastTickScripData = objLastTickData[scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]];
            if (arrLastTickScripData?.length > 0) {
                arrLastTickScripData[BEST5_INDEX.LAST_TRADE_PRICE] = (parseFloat(arrLastTickScripData[BEST5_INDEX.LAST_TRADE_PRICE]));
                arrLastTickScripData[BEST5_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] = (arrLastTickScripData[BEST5_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]); // Hari: 29-07-2023 show LTP change in recommendations scrip overview
                setArrScripInfo([...arrLastTickScripData]);
            } else { }
        } else { }
    }, [dispatch, scripOverviewData]);
    return (
        <>
            <ContainerHeader>
                <Container fluid className='p-0'>
                    <Row className='g-0 justify-content-between align-items-start stickysidemenu-top-header bdr-btm p-2'>
                        <Col md={7} className={`d-flex`}>
                            {scripOverviewData[WATCHLIST_GRID_INDEX.SERIES] ? 
                                <div>
                                    <div className={`d-flex align-items-center mb-1`}>
                                        <div className='font-medium font-size2 color-text text-uppercase me-1 line-height-1'>{scripOverviewData[WATCHLIST_GRID_INDEX.SYMBOL]}</div>
                                            <div className='chips-wrap'>
                                                <BzChip className='exchange-chip'>{scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE]}</BzChip>
                                            </div>
                                                {
                                                scripOverviewData[WATCHLIST_GRID_INDEX.DONT_MISS] !== '0' && scripOverviewData[WATCHLIST_GRID_INDEX.DONT_MISS]?.length > 0 &&
                                                <span className='icon-16 flex-shrink-0 icon-dontmiss icon-yellow mx-1'></span>                                          
                                        
                                                }
                                            <div className={`icon-14 flex-shrink-0 ms-1  ${syncWatchlist ? 'icon-sync icon-positive' : 'icon-nosync icon-dark'}`} onClick={handleSync}></div>
                                    </div>                                    
                                    <div className='font-regular font-size1 color-subtext line-height-1'>{getScripDisplayDescription(scripOverviewData)}</div>                                   
                                </div>
                                :
                                <div>
                                       <div className={`d-flex align-items-center mb-1`}>
                                            <div className='font-medium font-size2 color-text text-uppercase line-height-1 me-1'>{scripOverviewData[WATCHLIST_GRID_INDEX.SYMBOL]}</div>
                                            <div className='chips-wrap'>
                                                <BzChip className='exchange-chip'>{scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE]}</BzChip>
                                            </div>                                        
                                          <div className={`icon-14 flex-shrink-0 ms-1 ${syncWatchlist ? 'icon-sync icon-positive' : 'icon-nosync icon-dark'}`} onClick={handleSync}></div>
                                    </div>
                                    <div className='font-regular font-size1 color-subtext line-height-1'>{getScripDisplayDescription(scripOverviewData)}</div>                                    
                                    {
                                        scripOverviewData[WATCHLIST_GRID_INDEX.DONT_MISS] !== '0' && scripOverviewData[WATCHLIST_GRID_INDEX.DONT_MISS]?.length > 0 &&
                                        <div className='icon-16 icon-dontmiss icon-yellow flex-shrink-0 mx-1'></div>                                        
                                        
                                    }                                    
                                </div>
                            }
                        </Col>
                        <Col md={4} className='text-end'>
                            <div className='font-medium font-size2 color-text line-height-1'>{arrScripInfo?.length?parseFloat(arrScripInfo[BEST5_INDEX.LAST_TRADE_PRICE]).toFixed(scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]):scripOverviewData[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]}</div>
                            <span className={`font-medium font-size2 text-end line-height-1 ${arrScripInfo?.length? parseFloat(arrScripInfo[BEST5_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]) < 0 ? 'color-negative' : parseFloat(arrScripInfo[BEST5_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]) === 0 ? 'color-text' : 'color-positive': parseFloat(scripOverviewData[WATCHLIST_GRID_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]) < 0 ? 'color-negative' : parseFloat(scripOverviewData[WATCHLIST_GRID_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]) === 0 ? 'color-text' : 'color-positive'}`}>{arrScripInfo?.length?arrScripInfo[BEST5_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]:scripOverviewData[WATCHLIST_GRID_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]}</span>
                            <span className={`font-medium font-size2 line-height-1 ms-1 ${arrScripInfo?.length? parseFloat(arrScripInfo?.[BEST5_INDEX.NET_CHANGE_FROM_PRE_CLOSE]) < 0 ? 'color-negative' : parseFloat(arrScripInfo?.[BEST5_INDEX.NET_CHANGE_FROM_PRE_CLOSE]) === 0 ? 'color-text' : 'color-positive':parseFloat(scripOverviewData?.[WATCHLIST_GRID_INDEX.NET_CHANGE_FROM_PRE_CLOSE]) < 0 ? 'color-negative' : parseFloat(scripOverviewData?.[WATCHLIST_GRID_INDEX.NET_CHANGE_FROM_PRE_CLOSE]) === 0 ? 'color-text' : 'color-positive'}`}>({arrScripInfo?.length?arrScripInfo[BEST5_INDEX.NET_CHANGE_FROM_PRE_CLOSE]:scripOverviewData?.[WATCHLIST_GRID_INDEX?.NET_CHANGE_FROM_PRE_CLOSE]}%)</span>
                        </Col>
                        <Col md='auto' className='d-flex justify-content-end'>
                            <BzToolTip placement={'bottom'} TooltipMsg={'Close'}>
                                <div className='icon-16 icon-dark icon-close flex-shrink-0' onClick={() => {
                                    setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE.ZERO_PERCENT }; });
                                    setToggleSideContainer(false);
                                    setActiveMenu({});
                                }}>
                                </div>
                            </BzToolTip>
                        </Col>
                    </Row>
                </Container>
            </ContainerHeader>
            <ContainerBody>
                <Container fluid className='p-0 px-2 sticky-overview-height'>
                    <div className='my-3'>
                        <div className='scripoverview-fieldset'>
                            <div className={`${showDrop ? '' : 'scripoverview-fieldset-sidetray'}`}>
                                <Row className='g-0 my-1'>
                                    <Col className='submenu-wrapper-border'>
                                        <div className='submenu-wrapper horizontal-scroll-wrap pb-1'>
                                            <Stack direction="horizontal" className='d-flex justify-content-start submenu-wrapper'>
                                                {
                                                    arrMainMenus?.map((objMenu, i) => (
                                                        <>{!scripOverviewData[WATCHLIST_GRID_INDEX.SERIES] && objMenu?.id === "fundamentals" ? null : <div className={`submenuItem ${activeTabKey === objMenu?.id ? "active" : ""}`} onClick={() => { handleTabs(objMenu?.id); }} tabKey={objMenu?.id}>{objMenu?.name}</div>}</>
                                                    ))
                                                }
                                            </Stack>
                                        </div>
                                    </Col>
                                </Row>
                                {
                                    activeTabKey === "fundamentals" ?
                                        <>{scripOverviewData[WATCHLIST_GRID_INDEX.SERIES] ? <Fundamental isVertical={false} /> : null}</>
                                        : activeTabKey === 'technical' ?
                                            <Technical isVertical={false} />
                                            : <KeyStats isVertical={false} />
                                }
                                <div className='scripoverview-expand-btn-wrapper' onClick={handleDropClick}>
                                    <div className='scripoverview-expand-btn'>
                                        <div className={`icon-12 ${showDrop ? 'icon-arrowup' : 'icon-arrowdown'} icon-dark`}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='clear'></div>
                    <div className='my-4'>
                        <div className={`scripoverview-fieldset px-2`}>
                            <div className='scripoverview-legend'>MARKET DEPTH</div>
                            <div className={`${showDropMarket ? '' : 'scripoverview-fieldset-sidetray'}`}>
                                <Container fluid className={`p-0`}>
                                    <Row className={`g-0 p-1 align-items-center`}>
                                        {/* <Col className='font-medium font-size1 color-text'>Click on any price on Market Depth to trade</Col> */}
                                        <Col className='d-flex justify-content-end align-items-center'>
                                            <div className='btn-group bdr'>
                                                <BzButton onClick={() => handleMarketDepthChange(false)} className={`btn btn-sm ${marketDepthToShow ? '' : 'btn-primary'}`}><div className={`icon-16 icon-grid d-flex flex-shrink-0 ${marketDepthToShow ? 'icon-primary' : 'icon-light'}`} ></div></BzButton>
                                                {/* <BzButton onClick={() => handleMarketDepthChange(true)} className={`btn btn-sm ${marketDepthToShow ? 'btn-primary' : ''}`}><div className={`icon-16 icon-ladder d-flex flex-shrink-0 ${marketDepthToShow ? 'icon-light' : 'icon-primary'}`}></div></BzButton> */}
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0'>
                                        <Col className='d-flex align-items-center'>
                                            {
                                                arrDistinctScripExchanges.length > 0 && arrDistinctScripExchanges?.map((each) => (
                                                    <>
                                                        <div className='d-flex align-items-center me-4'>
                                                            {/* Vaibhav Singh: Update in mcx color dot */}
                                                            <input type='checkbox' checked={checkExchangeShow[each[WATCHLIST_GRID_INDEX.EXCHANGE]]} onClick={() => handleMarketDepth(each[WATCHLIST_GRID_INDEX.EXCHANGE], checkExchangeShow[each[WATCHLIST_GRID_INDEX.EXCHANGE]])} className='form-check-input' />
                                                            <div className={`allocate-dot ms-1 ${each[WATCHLIST_GRID_INDEX.EXCHANGE] === DISPLAY_EXCHANGE_NAME.NSE_EXCHANGE_TEXT || each[WATCHLIST_GRID_INDEX.EXCHANGE] === DISPLAY_EXCHANGE_NAME.NSX_EXCHANGE_TEXT || each[WATCHLIST_GRID_INDEX.EXCHANGE] === DISPLAY_EXCHANGE_NAME.MCX_EXCHANGE_TEXT ? 'nse-bid-allocation' : each[WATCHLIST_GRID_INDEX.EXCHANGE] === DISPLAY_EXCHANGE_NAME.MSX_EXCHANGE_TEXT ? 'mse-bid-allocation' : 'bse-bid-allocation'}`}></div>
                                                            <div className={`allocate-dot ms-1 ${each[WATCHLIST_GRID_INDEX.EXCHANGE] === DISPLAY_EXCHANGE_NAME.NSE_EXCHANGE_TEXT || each[WATCHLIST_GRID_INDEX.EXCHANGE] === DISPLAY_EXCHANGE_NAME.NSX_EXCHANGE_TEXT || each[WATCHLIST_GRID_INDEX.EXCHANGE] === DISPLAY_EXCHANGE_NAME.MCX_EXCHANGE_TEXT ? 'nse-ask-allocation' : each[WATCHLIST_GRID_INDEX.EXCHANGE] === DISPLAY_EXCHANGE_NAME.MSX_EXCHANGE_TEXT ? 'mse-ask-allocation' : 'bse-ask-allocation'}`}></div>
                                                            <div className='font-medium font-size1 color-text ms-1'>{each[WATCHLIST_GRID_INDEX.EXCHANGE]}</div>
                                                        </div>
                                                    </>
                                                ))
                                            }
                                        </Col>
                                    </Row>
                                </Container>
                                {!marketDepthToShow ?
                                    arrDistinctScripExchanges.length > 0 && arrDistinctScripExchanges?.map((each, index) => (
                                        <div key={index}>
                                            {checkExchangeShow[each[WATCHLIST_GRID_INDEX.EXCHANGE]] && <MarketDepthGrid scripData={each} />}
                                        </div>
                                    ))
                                    :
                                    <PriceLadderView isVertical={false} arrDistinctScripExchanges={arrDistinctScripExchanges?.filter(each => checkExchangeShow[each[WATCHLIST_GRID_INDEX.EXCHANGE]])} />
                                }
                                <div className='scripoverview-expand-btn-wrapper' onClick={handleDropClickMarketDepth}>
                                    <div className='scripoverview-expand-btn'>
                                        <div className={`icon-12 ${showDropMarket ? 'icon-arrowup' : 'icon-arrowdown'} icon-dark`}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='clear'></div>
                    <div className='my-3'>
                        <MarketMovement isVertical={false} handleDropClickMarketMovement={handleDropClickMarketMovement} showDropMarketMoveMent={showDropMarketMoveMent} />
                    </div>
                    <div className='clear'></div>
                    <div className='scripoverview-fieldset'>
                        <div className={`${showDropRecommendation ? '' : 'scripoverview-fieldset-sidetray'}`}>
                            <div className='submenu-wrapper-border'>
                                <div className='submenu-wrapper horizontal-scroll-wrap pb-1'>
                                    <Stack direction="horizontal" className='d-flex justify-content-start'>
                                        {
                                            arrRecNewsEvents?.map((objMenu, i) => (
                                                <div className={`submenuItem ${activeTabKeyRecNewsEvents === objMenu?.id ? "active" : ""}`} onClick={() => { handleTabsRec(objMenu?.id); }} tabKey={objMenu?.id}>{objMenu?.name}</div>
                                            ))
                                        }
                                    </Stack>
                                </div>
                            </div>
                            {
                                activeTabKeyRecNewsEvents === "events" ?
                                    <Container fluid className='p-0'>
                                        <Row className='g-0 p-2'>
                                            <Col>
                                                <div className="font-medium font-size2 color-text text-uppercase">NEWS &amp; ANNOUNCEMENT</div>
                                            </Col>
                                        </Row>
                                        <Row className='g-0'>
                                            <Col>
                                                {hotPursuitData?.length ?
                                                    <div className='transparent-card-wrap'>
                                                        {hotPursuitData?.length > 0 && hotPursuitData?.slice(0, newsShow ? hotPursuitData?.length : 3)?.map(objActiveNewsData => (
                                                            <NewsAnnouncements objActiveNewsData={objActiveNewsData} handleNewsDetails={handleNewsDetails} />
                                                        ))}
                                                    </div>
                                                    : bIsSectorWiseNewsDetailsApiPending && (hotPursuitData?.length === 0 || hotPursuitData?.length === undefined) ?
                                                        <div className='zero-state-loader-alerts zero-state-loader-alert-lg mrgauto'>
                                                            <BzLoader spinner={bIsSectorWiseNewsDetailsApiPending} spinnerContent={"Fetching Details"} />
                                                        </div>
                                                        : bIsSectorWiseNewsDetailsApiPending === false && (isHotPursuitAPIFailed || hotPursuitData?.length === 0 || hotPursuitData?.length === undefined) ?
                                                            <div className='zero-state-alerts zero-state-alerts-xl'>
                                                                <ZeroStates subText="No Data Found" isButtonShowing={false} icon='icon-64 icon-nodata mb-3 mrgauto' />
                                                            </div>
                                                            : null
                                                }
                                            </Col>
                                        </Row>
                                        <Row className='g-0'>
                                            <Col className='d-flex justify-content-center align-items-center'>
                                                <span>
                                                    <a href='#' className='font-medium font-size1' onClick={handleNews}>{newsShow ? 'View Less' : 'View More'}</a>
                                                </span>
                                            </Col>
                                        </Row>
                                        <Row className="g-0">
                                            <Col>
                                                <CorporateActions isVertical={false} scripOverviewData={scripOverviewData} handleEventsDetails={handleEventsDetails} nCorporateAction={nCorporateAction} arrCorporateActionTypes={arrCorporateActionTypes} setnCorporateAction={setnCorporateAction} />
                                            </Col>
                                        </Row>
                                    </Container>
                                    : activeTabKeyRecNewsEvents === 'alert' ?
                                        <Container fluid className='p-0'>
                                            <Row className='g-0'>
                                                <Col className='d-flex justify-content-center align-items-center'>
                                                    <div className='w-100 sideoverview-alert'>
                                                        <SideAlerts isVertical={false} />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Container>

                                        :
                                        <Recommendations objLayOut={{ horizonatal: true, wrap: false, sideOverview: true }} />
                            }
                            <div className='scripoverview-expand-btn-wrapper' onClick={handleDropClickRecommendation}>
                                <div className='scripoverview-expand-btn'>
                                    <div className={`icon-12 ${showDropRecommendation ? 'icon-arrowup' : 'icon-arrowdown'} icon-dark`}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </ContainerBody>
            <div className='side-overview-toggle-box shadow bdr w_70'>
                <div className='d-flex justify-content-center align-items-center bdr-btm p-2'>
                    <input type='checkbox' checked={chartToShow} onClick={() => { handleOptionAndChart({ chart: true, option: false }); }} className='form-check-input me-2' />
                    <div className="icon-20 icon-over-view-graph icon-primary"></div>
                </div>
                {bIsFutureAndOptionTab ?
                    <div className='d-flex justify-content-center align-items-center p-2'>
                        <input type='checkbox' checked={optionChainToShow} onClick={() => { handleOptionAndChart({ option: true, chart: false }); }} className='form-check-input me-2' />
                        <div className="icon-20 icon-over-view-link icon-primary"></div>
                    </div>
                    :
                    null
                }
            </div>
            {modals['HOT_PURSUIT_DATA'] && <NewsDetailsModal activeNews={activeNews} />}
            <CorporateActionsDetails detailedEvent={detailedEvent} nCorporateAction={nCorporateAction} arrCorporateActionTypes={arrCorporateActionTypes} />
        </>
    );

};
export default memo(SideOverview);